export default {
  header: 'Rýchla navigácia {assetDisplayName}',
};
